document.addEventListener('DOMContentLoaded', () => {
    const purchaseButton = document.getElementById('purchase');

    if (purchaseButton) {
        purchaseButton.addEventListener('click', (e) => {
            e.preventDefault();

            // Get dynamic values from the button's data attributes
            const productId = purchaseButton.getAttribute('data-product-id');
            const planId = purchaseButton.getAttribute('data-plan-id');
            const publicKey = purchaseButton.getAttribute('data-public-key');
            const productName = purchaseButton.getAttribute('data-product-name');

            // Validate that we have the required parameters
            if (!productId || !planId || !publicKey) {
                console.error('Freemius Checkout Error: Missing required product_id, plan_id, or public_key attributes on the purchase button.');
                return;
            }

            // Initialize the Freemius Checkout handler dynamically
            const handler = new FS.Checkout({
                product_id: productId,
                plan_id: planId,
                public_key: publicKey
            });

            // Open the checkout modal
            handler.open({
                name: productName || 'Product',
                licenses: 1,
                // purchaseCompleted: (response) => {
                //     // console.log('Purchase completed successfully');
                //     // Add your custom completion tracking/logic here
                // },
                purchaseCompleted: function(response) {

                   var total = response.purchase.gross.toString();

                    // Facebook Pixel
                    if (typeof fbq !== 'undefined') {
                        fbq('track', 'Purchase', {
                            currency: response.purchase.currency.toUpperCase(),
                            value: total
                        });
                    }

                    // Google Analytics 4
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'purchase', {
                            transaction_id: response.purchase.id.toString(),
                            value: total,
                            currency: response.purchase.currency.toUpperCase(),
                            items: [{
                                item_id: response.purchase.plugin_id.toString(),
                                item_name: productName || 'Product',
                                quantity: 1,
                                price: total
                            }]
                        });
                    }
                },
                success: (response) => {
                    // console.log('Checkout modal closed after purchase:');
                    // Add your custom redirection or UI updates here
                }
            });
        });
    }
});
